import { helpers, maxValue, minValue, required, integer, numeric } from '@vuelidate/validators'
import type { INumberOptions } from './useNumber.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useNumber(
  field: string,
  t: TInstance,
  options: INumberOptions,
) {
  return ({
    [`${field}`]: {
      ...(options.required && {
        required: helpers.withMessage(
          () => t('formValidatorMessages.number.required'),
          required,
        ),
      }),
      ...(options.onlyNumeric && {
        numeric: helpers.withMessage(
          () => t('formValidatorMessages.number.numeric'),
          numeric,
        ),
      }),
      ...(options.numberType === 'Int' && {
        int: helpers.withMessage(
          () => t('formValidatorMessages.number.int'),
          integer,
        ),
      }),
      ...(options.numberType === 'Float' && {
        float: helpers.withMessage(
          () => t('formValidatorMessages.number.float'),
          (value: string) => {
            return /^-?\d+(?:[.]\d+)?$/.test(String(value))
          },
        ),
      }),
      minValue: helpers.withMessage(
        () => t('formValidatorMessages.number.min', { number: options.min }),
        minValue(options.min),
      ),
      maxValue: helpers.withMessage(
        () => t('formValidatorMessages.number.max', { number: options.max }),
        maxValue(options.max),
      ),
    },
  })
}
